import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class Solution extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/solution/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/solution/save", {
            id: this.state.id,
            moeinAccountId: this.state.data.record.moeinAccountId,
            title: this.state.data.record.title,
            avatar: this.state.data.record.avatar,
            color: this.state.data.record.color,
            address: this.state.data.record.address,
            clientId: this.state.data.record.clientId,
            contractorId: this.state.data.record.contractorId,
            code: this.state.data.record.code,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setMoeinAccount(e) {
        this.state.data.record.moeinAccountId = e.value;
        this.state.data.record.moeinAccountName = e.label;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات پروژه" : "افزودن پروژه جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.renderSystemModuleModuleAccessMessage(this.state.innerStatus)}
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">کد</label>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ltr" maxLength="10" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">آدرس</label>
                                            <input defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="invoiceContact" className="title1">کارفرما</label>
                                            <SelectAsync
                                                value={!this.isNull(this.state.data.record.clientId) && this.state.data.record.clientId != this.defaultGuid() ? [{ value: this.state.data.record.clientId, label: this.state.data.record.clientName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب کارفرما"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 12)}
                                                onChange={e => this.setClient(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="invoiceContact" className="title1">پیمانکار</label>
                                            <SelectAsync
                                                value={!this.isNull(this.state.data.record.contractorId) && this.state.data.record.contractorId != this.defaultGuid() ? [{ value: this.state.data.record.contractorId, label: this.state.data.record.contractorName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب کارفرما"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 11)}
                                                onChange={e => this.setContractor(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
											<label className="title1">معین پیش فرض</label>
											<SelectAsync
												value={
													this.state.data.record.moeinAccountId != this.defaultGuid()
														? [
															{
																value: this.state.data.record.moeinAccountId,
																label: this.state.data.record.moeinAccountName,
															},
														]
														: null
												}
												isMulti={false}
												placeholder="جستجو و انتخاب معین"
												defaultOptions
												loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
												onChange={(e) => this.setMoeinAccount(e)}
											/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}